import { Record } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import type ServiceHookResult from "utilities/interfaces/service-hook-result";
import ShareSpacePanel from "models/interfaces/share-space-panel";
import ShareSpaceRecord from "./share-spaces/share-space-record";

const defaultValues: ShareSpacePanel =
    RecordUtils.defaultValuesFactory<ShareSpacePanel>({
        shareSpace: undefined,
        emails: [],
        message: "",
    });

export default class ShareSpacePanelRecord
    extends Record(defaultValues)
    implements ShareSpacePanel
{
    // -----------------------------------------------------------------------------------------
    // #region Properties
    // -----------------------------------------------------------------------------------------

    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // #endregion Properties

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: ShareSpacePanel) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.shareSpace != null) {
            params.shareSpace = RecordUtils.ensureRecord(
                params.shareSpace,
                ShareSpaceRecord
            );
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------
    /**
     * Extracts values from ServiceHookResult and returns a new instance.
     */
    public fromServiceHookResult(
        serviceHookResult: ServiceHookResult<Partial<ShareSpacePanel>>
    ): ShareSpacePanelRecord {
        return this.with({
            ...serviceHookResult,
            ...serviceHookResult.resultObject,
        });
    }

    /**
     * Merges new values into the record and returns a new instance.
     */
    public with(values: Partial<ShareSpacePanel>): ShareSpacePanelRecord {
        return new ShareSpacePanelRecord(
            Object.assign(this.toJS(), values) as ShareSpacePanelRecord
        );
    }

    public hasShareItems(): boolean {
        return (
            !!this.shareSpace?.shareSpaceItems &&
            this.shareSpace.shareSpaceItems?.length > 0
        );
    }

    public getShareItemsLength(): number {
        return this.shareSpace?.shareSpaceItems
            ? this.shareSpace.shareSpaceItems?.length
            : 0;
    }

    // #endregion Public Methods
}
